import axiosInstance from '../axios';
import { Location } from '../types/location';

export interface AddLocationPayload {
    latitude: number;
    longitude: number;
    comment: string;
    sleep_day: string;
}

export async function getAllLocations(): Promise<Location[]> {
    const response = await axiosInstance.get<Location[]>("/sleep/getall");
    return response.data;
}

export async function addLocation(payload: AddLocationPayload): Promise<Location> {
    const response = await axiosInstance.post<Location>("/sleep/add", payload);
    return response.data;
}

export async function updateLocation(id: number, comment: string): Promise<Location> {
    const response = await axiosInstance.put<Location>(`/sleep/update/${id}`, { comment });
    return response.data;
}

export async function deleteLocation(id: number): Promise<void> {
    await axiosInstance.delete(`/sleep/delete/${id}`);
}

export async function getVersion(): Promise<string> {
    const response = await axiosInstance.get<{ version: string }>("/sleep/version");
    return response.data.version;
}
